import React, { useState, useEffect } from "react";
import LayerAdmin from "../LayerAdmin";
import { toast } from "react-toastify";
import ButtonLoader from "../../zamzam/components/ButtonLoader";
import { useNavigate, useParams } from "react-router-dom";
import URL_MAPPING from "../../../routes/constants";
import axios from "axios";
import { setTime } from "react-datepicker/dist/date_utils";
import {  updateTeri,getDropdowns } from "../api/territory"; 
import {getDropdownchannel, getSpecificPerm,updatePerm,getDropdownsales  } from "../api/auth"; 
type SalesOffice = {
  sales_office_id: string;
  name: string;
};
type Channel = {
  channels: string;
  name: string;
  channel_id: string
};
const EditPerm = () => {
  const [formData, setFormData] = useState({
    id: "",
    role_name: "",
 
    values: [],
    channelId: [] as string[], 

    sales_offices: [] as string[],
  });

  
 const [values, setValues] = useState<SalesOffice[]>([]);

   const [valuesChannel, setValuesChannel] = useState<Channel[]>([]);
  const [loading, setLoading] = useState(false);
  const [invalidFields, setInvalidFields] = useState<string[]>([]);
  const navigate = useNavigate();
  const { id } = useParams();

  const handleChange = (e: any) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const getInputClass = (field: string) =>
    `w-full border px-3 py-2 rounded ${
      invalidFields.includes(field) ? "border-red-500" : ""
    }`;

  const handleSubmit = async (e: any) => {
    e.preventDefault();
   
const paramsObj = {
  sales_office_ids: formData.sales_offices,
  channel_ids: formData.channelId, // Use the updated channelId state}

}

    try {
      setLoading(true);
      const emptyFields = Object.entries(formData)
        .filter(([_, value]) => value === null || value === "")
        .map(([key]) => key);

      setInvalidFields(emptyFields);

      if (emptyFields.length > 0) {
        toast.error("Please fill all required fields.");
        return;
      }
      // await axios.put(
      //   `https://staging.sfa.berain.com.sa/web/api/v1/admin/territory-mappings/${id}`,
      //   paramsObj
      // );

       const response = await updatePerm(paramsObj, formData.id);
              if (!response) {
                console.warn("Invalid or empty response:", response);
                toast.error("Invalid or empty response");
                return;
              }
      toast.success("Permissions updated successfully!");
      setTimeout(() => {
        navigate(URL_MAPPING.ROLEPERMISSION);
      }, 2000);
     
    } catch (error: any) {
      console.error("Error fetching territory data:", error);
      if (error?.response?.status === 404) {
        toast.error("Route not found, Please try again later",{
          autoClose: false,
          closeOnClick: true,
          draggable: true,
        });
      } else if (error?.response?.status === 500) {
        toast.error("Error while fetching the territory",{
          autoClose: false,
          closeOnClick: true,
          draggable: true,
        });
      } else {
        const detail = error?.response?.data?.detail;
        if (Array.isArray(detail)) {
          detail.forEach((err) => toast.error(err.msg,{
            autoClose: false,
            closeOnClick: true,
            draggable: true,
          }));
        } else {
          toast.error(detail?.msg || detail || "An unexpected error occurred.",{
            autoClose: false,
            closeOnClick: true,
            draggable: true,
          });
        }
      }
    } finally {
      setLoading(false);
    }
  };

    useEffect(() => {
      const fetchMappings = async () => {
        try {
          const res = await getDropdownsales();
          if (!res) {
            toast.error("No data received or malformed response");
            console.warn("No data received or malformed response:", res);
            return;
          }
          setValues(res.sales_offices || []);
        } catch (error: any) {
          console.error("Failed to fetch data:", error);
          if (error?.response?.status === 404) {
            toast.error("Route not found, Please try again later");
          } else if (error?.response?.status === 500) {
            toast.error("Error while fetching");
          } else {
            const detail = error?.response?.data?.detail;
            if (Array.isArray(detail)) {
              detail.forEach((err) => toast.error(err.msg));
            } else {
              toast.error(
                detail?.msg || detail || "An unexpected error occurred."
              );
            }
          }
        } finally {
          setLoading(false);
        }
      };
  
      fetchMappings();
    }, []);
  useEffect(() => {
     const fetchMappings = async () => {
       try {
         const res = await getDropdownchannel();
         if (!res) {
           toast.error("No data received or malformed response");
           console.warn("No data received or malformed response:", res);
           return;
         }
 
         setValuesChannel(res.channels || []);
       } catch (error: any) {
         console.error("Failed to fetch employee data:", error);
         if (error?.response?.status === 404) {
           toast.error("Route not found, Please try again later");
         } else if (error?.response?.status === 500) {
           toast.error("Error while fetching the employee");
         } else {
           const detail = error?.response?.data?.detail;
           if (Array.isArray(detail)) {
             detail.forEach((err) => toast.error(err.msg));
           } else {
             toast.error(
               detail?.msg || detail || "An unexpected error occurred."
             );
           }
         }
       } finally {
         setLoading(false);
       }
     };
 
     fetchMappings();
   }, []);
 
  useEffect(() => {
    const fetchData = async () => {
      try {
    

         

         const response = await getSpecificPerm(id as string);
               if (!response) {
                 console.warn("Invalid or empty  response:", response);
                 toast.error("Invalid or empty  response");
                 return;
               }
        const data = response;
        setFormData({
          id: data.id,
          role_name: data.role_name || "",
      
          values: data.values || [],
          channelId: data.channels || [],
          sales_offices: Array.isArray(data.sales_offices) ? data.sales_offices : [],
          // sales_offices

          // session_entity_key: data.session_entity_key || "",
          // territory_entity_key: data.territory_entity_key || "",
        });
      } catch (error: any) {
        console.error("Error fetching customer data:", error);
        if (error?.response?.status === 404) {
          toast.error("Route not found, Please try again later");
        } else if (error?.response?.status === 500) {
          toast.error("Error while fetching the employee");
        } else {
          const detail = error?.response?.data?.detail;
          if (Array.isArray(detail)) {
            detail.forEach((err) => toast.error(err.msg));
          } else {
            toast.error(
              detail?.msg || detail || "An unexpected error occurred."
            );
          }
        }
      }
    };
    fetchData();
  }, []);
 
  return (
    <LayerAdmin>
      <div className="flex items-center px-5 pt-5 gap-3">
        <button
          onClick={() => window.history.back()}
          className="bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.1"
            width="10"
            height="10"
            viewBox="0 0 256 256"
            xmlSpace="preserve"
          >
            <g
              style={{
                stroke: "none",
                strokeWidth: 0,
                strokeDasharray: "none",
                strokeLinecap: "butt",
                strokeLinejoin: "miter",
                strokeMiterlimit: 10,
                fill: "none",
                fillRule: "nonzero",
                opacity: 1,
              }}
              transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
            >
              <polygon
                points="20.48,45 59.75,90 69.52,81.48 37.69,45 69.52,8.52 59.75,0 "
                style={{
                  stroke: "none",
                  strokeWidth: 1,
                  strokeDasharray: "none",
                  strokeLinecap: "butt",
                  strokeLinejoin: "miter",
                  strokeMiterlimit: 10,
                  fill: "rgb(0,0,0)",
                  fillRule: "nonzero",
                  opacity: 1,
                }}
                transform="  matrix(1 0 0 1 0 0) "
              />
            </g>
          </svg>
        </button>
        <h3 className="text-xl font-bold text-gray-700">Edit Permissions</h3>
      </div>
      <form onSubmit={handleSubmit} className="p-4 lg:w-1/3 sm:w-full">
        <div className="my-2">
          <label className="block font-semibold mb-1">Role ID</label>
          <input name="id" disabled value={formData.id} />
        </div>

        <div className="my-2">
          <label className="block font-semibold mb-1">Role Name </label>
          <input
            type="text"
            name="role_name"
            disabled
            value={formData.role_name}
            onChange={handleChange}
            className={getInputClass("role_name")}
            placeholder="Role Name"
          />
        </div>
        {/* <div className="my-2">
          <label className="block font-semibold mb-1">Channels </label>
          <input
            type="text"
            name="channelId"
           
            value={formData.channelId}
            onChange={handleChange}
            className={getInputClass("channelId")}
            placeholder="Role Name"
          />
        </div> */}
{/* --- Channels Dropdown with Chips --- */}
<div className="my-2">
  <label className="block font-semibold mb-1">Channels</label>

  {/* Chips */}
  <div className="flex flex-wrap gap-2 mb-2">
    {formData.channelId.map((channelId, index) => {
      const channel = valuesChannel.find((c) => c.channel_id === channelId);
      return (
        <span
          key={index}
          className="bg-purple-100 text-purple-800 text-sm px-3 py-1 rounded-full flex items-center"
        >
          {channel?.name || channelId}
          <button
            type="button"
            onClick={() => {
              const updated = [...formData.channelId];
              updated.splice(index, 1);
              setFormData((prev) => ({
                ...prev,
                channelId: updated,
              }));
            }}
            className="ml-2 text-purple-600 hover:text-red-600"
          >
            &times;
          </button>
        </span>
      );
    })}
  </div>

  {/* Dropdown */}
  <select
    className="w-full border px-3 py-2 rounded"
    onChange={(e) => {
      const selectedId = e.target.value;
      if (
        selectedId &&
        !formData.channelId.includes(selectedId)
      ) {
        setFormData((prev) => ({
          ...prev,
          channelId: [...prev.channelId, selectedId],
        }));
      }
      e.target.selectedIndex = 0; // reset to default
    }}
  >
    <option value="">Select Channel</option>
    {valuesChannel.map((channel) => (
      <option key={channel.channel_id} value={channel.channel_id}>
        {channel.name}
      </option>
    ))}
  </select>
</div>




        <div className="my-2">
  <label className="block font-semibold mb-1">Sales Offices</label>

  {/* Display Selected Sales Offices as Chips */}
  <div className="flex flex-wrap gap-2 mb-2">
    {formData.sales_offices.map((officeId, index) => {
      const office = values.find((v) => v.sales_office_id === officeId);
      return (
        <span
          key={index}
          className="bg-teal-100 text-teal-800 text-sm px-3 py-1 rounded-full flex items-center"
        >
          {office?.name || officeId}
          <button
            type="button"
            onClick={() => {
              const updated = formData.sales_offices.filter((_, i) => i !== index);
              setFormData((prev) => ({
                ...prev,
                sales_offices: updated,
              }));
            }}
            className="ml-2 text-teal-600 hover:text-red-600"
          >
            &times;
          </button>
        </span>
      );
    })}
  </div>

  {/* Dropdown Select to Add Sales Office */}
  <select
    className="w-full border px-3 py-2 rounded"
    onChange={(e) => {
      const selectedId = e.target.value;
      if (
        selectedId &&
        !formData.sales_offices.includes(selectedId)
      ) {
        setFormData((prev) => ({
          ...prev,
          sales_offices: [...prev.sales_offices, selectedId],
        }));
      }
      e.target.value = ""; // reset select after adding
    }}
    defaultValue=""
  >
    <option value="" disabled>
      Select a Sales Office
    </option>
    {values
      .filter((v) => !formData.sales_offices.includes(v.sales_office_id))
      .map((v) => (
        <option key={v.sales_office_id} value={v.sales_office_id}>
          {v.name}
        </option>
      ))}
  </select>
</div>

        

        

      

        <button
          type="submit"
          disabled={loading}
          className="bg-teal-500 text-white px-6 py-2 rounded hover:bg-teal-600 flex items-center gap-2"
        >
          Update Permissions {loading && <ButtonLoader />}
        </button>
      </form>
    </LayerAdmin>
  );
};

export default EditPerm;
